import { useSelector } from 'react-redux';
import { selectMyHomeId } from '../../../selectors/selectMyHomeId';
import { selectMyHomesList } from '../../../selectors/selectMyHomesList';

export const useGetMyHomeListing = () => {
  const _myHomeItems = useSelector(selectMyHomesList);
  const myHomeId = useSelector(selectMyHomeId);

  if (!_myHomeItems) {
    return;
  }

  if (_myHomeItems.length === 0) {
    return [];
  }

  /**
   * Копипастим исходный список объектов моего дома, так как
   * ниже splice, по после useSelector он read only (let вместо const не помогает)
   */
  const myHomeItems = _myHomeItems.slice(0);
  const index = myHomeItems.findIndex(item => item.id === myHomeId);
  myHomeItems.splice(0, 0, {
    ...myHomeItems.splice(index, 1)[0],
    /**
     * Так как листинг и данные запрашиваются параллельно, то у активной карточки
     * может придти будто бы ее не видел пользователь, убираем это принудительно (красный кружок)
     */
    redPoint: false,
  });

  return myHomeItems;
};
